var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "my-2 text-right" },
        [
          _c(
            "b-button",
            {
              attrs: {
                "data-cy": "add",
                size: "sm",
                variant: "outline-primary"
              },
              on: { click: _vm.addSubstituteModal }
            },
            [_vm._v(" Agregar ")]
          )
        ],
        1
      ),
      _c("SubstituteTable", {
        on: {
          "edit-substitute": _vm.editUser,
          "enable-substitute": _vm.enableSubstitue,
          "disable-substitute": _vm.disableSubstitue,
          "store-substitute": _vm.storeSubstitue
        }
      }),
      _c(
        "b-modal",
        {
          ref: "substitute-modal",
          attrs: {
            size: "lg",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Suplencia"
          }
        },
        [
          _c("form", { attrs: { "data-vv-scope": "data-user" } }, [
            _c("div", { staticClass: "row mb-5" }, [
              _c(
                "div",
                { staticClass: "col-12 mt-3" },
                [
                  _c("list-user", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      name: "user",
                      label: "Usuarios",
                      danger: _vm.errors.has("data-user.user"),
                      "danger-text": _vm.errors.first("data-user.user")
                    },
                    model: {
                      value: _vm.process.user,
                      callback: function($$v) {
                        _vm.$set(_vm.process, "user", $$v)
                      },
                      expression: "process.user"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-6 mt-3" },
                [
                  _c("label", [_vm._v("Fecha inicio suplencia")]),
                  _c("datepicker", {
                    staticClass: "w-100",
                    attrs: {
                      "data-cy": "start-date",
                      name: "issueDate",
                      language: _vm.es
                    },
                    model: {
                      value: _vm.process.start,
                      callback: function($$v) {
                        _vm.$set(_vm.process, "start", $$v)
                      },
                      expression: "process.start"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-6 mt-3" },
                [
                  _c("label", [_vm._v("Fecha fin suplencia")]),
                  _c("datepicker", {
                    staticClass: "w-100",
                    attrs: {
                      "data-cy": "final-date",
                      name: "issueDate",
                      language: _vm.es
                    },
                    model: {
                      value: _vm.process.end,
                      callback: function($$v) {
                        _vm.$set(_vm.process, "end", $$v)
                      },
                      expression: "process.end"
                    }
                  })
                ],
                1
              )
            ]),
            _vm.error.message !== ""
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
                    staticStyle: { height: "32px" }
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(" " + _vm._s(_vm.error.message) + " ")
                    ])
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "d-flex justify-content-end mt-3" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      "data-cy": "next-button",
                      variant: "outline-primary"
                    },
                    on: { click: _vm.saveChanges }
                  },
                  [_vm._v(" Guardar ")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }